<script lang="ts">
	import classNames from 'classnames';
	import type { FilterSortOption } from '../../../types';
	import { FilterSortDropdown } from './FilterSortDropdown';

	let { sorts, retainSearchParams = false, scrollTarget = undefined, ...rest }: Props = $props();

	interface Props {
		sorts: FilterSortOption[][];
		retainSearchParams?: boolean;
		scrollTarget?: string;
		class?: string;
	}
</script>

<div class={classNames('flex flex-col items-center gap-4 sm:flex-row', rest.class)}>
	{#each sorts as options, sortIndex}
		<FilterSortDropdown {options} {sortIndex} {retainSearchParams} {scrollTarget} />
	{/each}
</div>
